import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { CustomButton, FilterBar, TableData } from '../../../components';
import { confirmAlert, errorAlert } from '../../../helpers/alerts';
import { getCommercesService } from '../../../services/client/commerceService';
import { setCommerces } from '../../../redux/slices/client/commerceSlice';
import { Box } from '@mui/material';
import FileInput from 'components/common/FileInput';
import { AddTask, Create, FileDownload } from '@mui/icons-material';
import { downloadStaticFile } from 'helpers/util';
import readXlsxFile from 'read-excel-file'
import { createMultipleSalePointsService } from 'services/client/salePointService';
import { setLoading } from 'redux/slices/uiSlice';

const ImportSalePointScreen = () => {
  const dispatch = useDispatch();
  const { commerces } = useSelector((store) => store.commerces);
  const [list, setList] = useState([])
  const [commerce, setCommerce] = useState(null)

  useEffect(() => {
    getCommercesService(undefined, true)
      .then((response) => dispatch(setCommerces(response)))
      .catch((e) => errorAlert(e))
    // eslint-disable-next-line
  }, []);

  const handlerSubmit = (data) => {
    setCommerce(data.commerce)
  }

  const handlerCreate = () => {
    if (!commerce) {
      return errorAlert({
        message: 'Debe seleccionar un comercio antes de crear los puntos de venta.'
      });
    };
    dispatch(setLoading(true));
    createMultipleSalePointsService({ list, commerce }).then(() => {
      setList([]);
      confirmAlert({
        title: "¡Los puntos de venta se han creado exitosamente! ",
        icon: 'success',
        showCancelButton: false,
      });
    }).catch((e) => errorAlert(e))
      .finally(() => dispatch(setLoading(false)));
  }

  const handlerFile = (file) => {
    if (!file) return;
    if (file.type !== 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') return
    readXlsxFile(file).then((rows) => {
      setList(rows.filter((_, index) => index > 1).map((row) => ({
        name: row[0],
        description: row[1],
        email: row[2],
        password: row[3],
        user_name: row[4],
        user_lastname: row[5],
        type: [
          row[6] ? 'Portal Web' : null,
          row[7] ? 'Aplicación Móvil' : null,
          row[8] ? 'Web Service' : null,
        ].filter(Boolean),
        days: [
          row[9] ? 'monday' : null,
          row[10] ? 'tuesday' : null,
          row[11] ? 'wednesday' : null,
          row[12] ? 'thursday' : null,
          row[13] ? 'friday' : null,
          row[14] ? 'saturday' : null,
          row[15] ? 'sunday' : null,
        ].filter(Boolean),
      })));
    });
  }

  const handlerDownload = () => {
    downloadStaticFile('/templates/Plantilla_Puntos_de_Venta.xlsx', 'Plantilla_Puntos_de_Venta.xlsx');
  }

  return (
    <>
      <FilterBar
        handlerFilter={handlerSubmit}
        showTitle={false}
        filters={[
          {
            name: 'commerce',
            label: "Comercio",
            type: "select",
            data: commerces.map(({ _id: id, username }) => ({ id, name: username }))
          },
        ]}
      />
      <Box mt={-5}>
        <TableData
          headerButtons={[
            <CustomButton
              icon={<FileDownload />}
              key="dowloadDetails"
              name={"Plantilla"}
              click={handlerDownload}
            />,
            <FileInput
              dark={true}

              key="addCommerce"
              name={"Cargar archivo"}
              onChange={handlerFile}
            />,
            list.length > 0 && <CustomButton
              dark={true}
              icon={<AddTask />}
              key="dowloadDetails"
              name={"Crear"}
              click={handlerCreate}
            />,
          ]}
          dataRows={list}
          dataTitle={[
            "Nombre",
            "Descripción",
            "Tipo",
            "Usuario",
            "Contraseña",
          ]}
          formatter={({ name, password, description, type, days, email }) => [
            name,
            description,
            type ? Array.isArray(type) ? type.join(', ') : type : '',
            email,
            password,
          ]}
        />
      </Box>
    </>
  )
}

export default ImportSalePointScreen